<app-information-screen [secondaryColor]="secondaryColor"
                        [title]="title"
                        [primaryContent]="description">
</app-information-screen>

@if (slides?.length) {

<div class="instruction-carousel">

  @if (slides[currentSlideIndex].title) {
  <h3 class="slide-title">
    {{ slides[currentSlideIndex].title }}
  </h3>
  }

  @if (slides[currentSlideIndex].text) {
  <p class="slide-caption">
    {{ slides[currentSlideIndex].text }}
  </p>
  }

  <div class="carousel-image-wrapper">
    @if (shouldShowVideo(currentSlideIndex)) {
    <video class="instruction-image"
           [src]="slides[currentSlideIndex].video"
           autoplay
           muted
           loop
           playsinline
           preload="metadata"
           (error)="onVideoError(currentSlideIndex)">
    </video>
    } @else {
    <img class="instruction-image"
         [src]="slides[currentSlideIndex].image"
         [alt]="slides[currentSlideIndex].alt || slides[currentSlideIndex].text || title" />
    }
  </div>

  @if (slides.length > 1) {
  <div class="slider-actions" [class.single]="isFirstSlide || isLastSlide">
    @if (!isFirstSlide) {
    <button type="button" class="slider-btn" (click)="previousSlide()">
      {{ 'Intellitrailer.Rental.Nuwiel.Slider.PreviousStep' | translate : 'Previous Step' }}
    </button>
    }

    @if (!isLastSlide) {
    <button type="button" class="slider-btn" (click)="nextSlide()">
      {{ 'Intellitrailer.Rental.Nuwiel.Slider.NextStep' | translate : 'Next Step' }}
    </button>
    }
  </div>

  <div class="slide-counter">
    {{ currentSlideIndex + 1 }}/{{ slides.length }}
  </div>
  }
</div>
}
